// src/admin/utils/loanStatus.ts — UI-side knowledge of loan_status enum and allowed next actions.
// The server enforces transitions via trigger; this file drives button visibility only.

import type { Database } from '@/lib/database.types';

type LoanStatus = Database['public']['Enums']['loan_status'];

export const LOAN_STATUS_LABEL: Record<LoanStatus, string> = {
  pending_approval: 'Pending approval',
  approved: 'Approved',
  disbursement_pending: 'Disbursement pending',
  active: 'Active',
  repaid: 'Repaid',
  delinquent: 'Delinquent',
  default: 'Default',
  restructured: 'Restructured',
  cancelled: 'Cancelled',
  disbursement_failed: 'Disbursement failed',
};

export const LOAN_STATUS_TONE: Record<LoanStatus, 'neutral' | 'positive' | 'warn' | 'danger' | 'info'> = {
  pending_approval: 'info',
  approved: 'info',
  disbursement_pending: 'info',
  active: 'positive',
  repaid: 'positive',
  delinquent: 'warn',
  default: 'danger',
  restructured: 'neutral',
  cancelled: 'neutral',
  disbursement_failed: 'danger',
};

export type LoanAction =
  | 'approve' | 'cancel' | 'mark_disbursed' | 'record_payment'
  | 'request_restructure' | 'recommend_default' | 'force_fail_disbursement'
  | 'reopen_cancelled';

export function allowedActions(status: LoanStatus): LoanAction[] {
  switch (status) {
    case 'pending_approval': return ['approve', 'cancel'];
    case 'approved': return ['mark_disbursed', 'cancel'];
    case 'disbursement_pending': return ['force_fail_disbursement'];
    case 'disbursement_failed': return ['mark_disbursed', 'cancel'];
    case 'active': return ['record_payment', 'request_restructure'];
    case 'delinquent': return ['record_payment', 'request_restructure', 'recommend_default'];
    case 'restructured': return ['record_payment', 'recommend_default'];
    case 'repaid': return [];
    case 'default': return [];
    case 'cancelled': return ['reopen_cancelled'];
  }
}
